import React from "react";
import themePropTypes from "../theme-prop-types";
import { fetchImage } from "../../api/photo-upload";
import userIcon from "./assets/icons/td-user.svg";

class WebImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      source: null,
      loading: true,
      classIco: null,
      title: null
    };
  }

  componentDidMount() {
    const { url, image, title } = this.props;

    if (image && !url) {
      return this.setState({ source: image, loading: false });
    }

    if (url) {
      fetchImage(url)
        .then(source => {
          if (source) {
            this.setState({
              source,
              loading: false
            });
          } else if (image) {
            this.setState({
              source: image,
              loading: false
            });
          } else {
            this.setState({
              source: null,
              loading: false,
              classIco: "image-web-sdk-doc"
            });
          }
        })
        .catch(() => {
          this.setState({ loading: false, title });
        });
    } else if (title) {
      this.setState({ title, loading: false });
    } else {
      this.setState({
        source: userIcon,
        loading: false,
        classIco: "image-web-sdk-ico"
      });
    }
  }

  webImageStyles = layout => {
    const styles = {};

    if (typeof layout?.width !== "undefined") {
      styles.width = layout.width;
    }

    if (typeof layout?.height !== "undefined") {
      styles.height = layout.height;
    }

    return styles;
  };

  render() {
    const {
      size,
      align,
      image,
      url,
      params,
      layout,
      components: { Loader },
      properLink
    } = this.props;

    const { loading, source, classIco, title } = this.state;
    const paramsClasses = params ? params.split("|").join(" ") : "";

    return image && !url ? (
      <div className={`image-placeholder-websdk ${image} ${paramsClasses}`} />
    ) : (
      <div
        className={`image-wrapper-web-sdk ${paramsClasses}`}
        style={{
          width: size || "auto",
          height: size || "auto",
          float: align ?? "none"
        }}
      >
        <div className='image-container-web-sdk'>
          {loading ? (
            <Loader isHidden={properLink} />
          ) : classIco ? (
            <div className={classIco} />
          ) : title ? (
            <div className='placeholder-websdk'>{title}</div>
          ) : (
            <img
              src={source}
              alt='Preview'
              className='image-web-sdk'
              style={this.webImageStyles(layout)}
            />
          )}
        </div>
      </div>
    );
  }
}

WebImage.propTypes = themePropTypes.image;

export default WebImage;
